// options are included when the price is 0 and it's not an insurance
import { OfferOption } from '@/types/offer';

export const offerOptionIsIncluded = (offerOption: OfferOption) => {
  return offerOption.price === 0 && offerOption.category_identifier !== 'insurance';
}